import React, { Component } from 'react'
import LinksBase from './LinksBase'
import LinksAmbiental from './LinksAmbiental'
import LinksLns from './LinksLns'

class MenuSystem extends Component {
    subMenuOpened = false

    openSubMenu(e) {
        const clickedElement = e.target
        const isSubMenuLink = clickedElement.closest('.hdv-submenu') || clickedElement.closest('.hdv-menu-item-grupo')
        
        if (isSubMenuLink) {
            return
        }
        
        const menuParent = e.currentTarget
        const clickedSubMenu = menuParent.querySelector('.hdv-menu-item-grupo')
        
        if (!clickedSubMenu) {
            return
        }
        
        if (this.subMenuOpened && this.subMenuOpened === clickedSubMenu) {
            this.subMenuOpened.classList.remove("hdv-menu-item-grupo-open")
            this.subMenuOpened = false
            return
        }
        
        if (this.subMenuOpened) {
            this.subMenuOpened.classList.remove("hdv-menu-item-grupo-open")
        }
        
        this.subMenuOpened = clickedSubMenu
        this.subMenuOpened.classList.add("hdv-menu-item-grupo-open")
    }

    pathIncludes(paths) {
        let items = []
        let results = []
        items = Array.isArray(paths) ? paths : new Array(paths)
        items?.forEach((path) => results.push(this.props.pathCurrent.includes(path)))

        return results.some((i) => i) ? "hdv-menu hdv-menu-selected" : "hdv-menu"
    }

    render() {
        let moduloSelected = this.props.modulo

        const modulos = {
            base:  <LinksBase pathCurrent={this.props.pathCurrent} openSubMenu={(e) => this.openSubMenu(e)} pathIncludes={(paths) => this.pathIncludes(paths)}/>,
            ambiental: <LinksAmbiental pathCurrent={this.props.pathCurrent} openSubMenu={(e) => this.openSubMenu(e)} pathIncludes={(paths) => this.pathIncludes(paths)}/>,
            lns: <LinksLns pathCurrent={this.props.pathCurrent} openSubMenu={(e) => this.openSubMenu(e)} pathIncludes={(paths) => this.pathIncludes(paths)}/>
        }

        return (
            modulos[moduloSelected]
        )
    }
}

export default MenuSystem